const ScrollControlFunc = {
  // スクロール禁止
  noScroll: () => {
    document.addEventListener("wheel", ScrollControlFunc.scrollControl, { passive: false });
    document.addEventListener("touchmove", ScrollControlFunc.scrollControl, { passive: false });
  },
  // スクロール禁止解除
  returnScroll: () => {
    document.removeEventListener("wheel", ScrollControlFunc.scrollControl, { passive: false });
    document.removeEventListener("touchmove", ScrollControlFunc.scrollControl, { passive: false });
  },
  // スクロール禁止関数
  scrollControl: (event) => {
    event.preventDefault();
  }
}
export default ScrollControlFunc;